import type { TFavoriteColors } from 'api/swagger';

export const favoriteColorMapping: Record<TFavoriteColors, string> = {
  red: '#ff7875',
  orange: '#ffc069',
  green: '#95de64',
  blue: '#69b1ff',
  purple: '#9254de',
  magenta: '#f759ab',
};
